import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { EnvironmentDataService } from './environment-data.service';
import { SecurityDataService } from './security-data.service';

@Injectable()
export class CookiePolicyAcceptanceVerifierService  {

  constructor(
    private _injector:Injector,
    private _router: Router,
    private _http: HttpClient,
    private _environmentDataService: EnvironmentDataService,
    private _securityDataService: SecurityDataService) 
  { }

  public async check(routerStateSnapshot:RouterStateSnapshot):Promise<boolean> {
    this._debug('canActivate()', 'state.url', routerStateSnapshot.url, true)

    //Url originale di caricamento dell'applicazione
    const externalUrl = window.location.href;
    //Url di navigazione interna gestita da angular
    const internalUrl = routerStateSnapshot.url;

    this._debug('_check()', 'window.location.href (external url)', window.location.href)
    this._debug('_check()', 'state.url (internal url)', routerStateSnapshot.url)

    if(this._environmentDataService.environment.getValue('cookiesConsentRequired') && !['/setpassword','/set-password','/home'].includes(internalUrl)) {
      const acceted = this._securityDataService.cookiePolicyAccepted()
      if(acceted)
          return true;
      else{
        //Memorizza la pagina di destinazione in modo da poterlo reindirizzare dopo la login
        const urlFragments = externalUrl.split("/").slice(3);
        localStorage.setItem('redirectUrl', urlFragments.join("/"));
        this._router.navigate(['/home']);
        return false;
      }
    }
    else
      return true;
  }

  private _debug = (func, key, value, primary?: boolean) => {
    let color, background;
    if(primary){
      color = 'white';
      background = 'violet';
    }else{
      color = 'black';
      background = 'transparent';
    }
    console.log(`%c CookiePolicyAcceptanceVerifierService.${func} - ${key}: ${value}`, `background: ${background}; color: ${color}; border:2px solid violet; padding: 2px;`);
  }
}
